export const GAMIFICATION_VIEW_EN = {
  YourProductivityDashboard: 'Your Productivity Dashboard',
  AchievementsCompleted: 'Achievements Completed',
  LoadingYourProductivityMetrics: 'Loading your productivity metrics...',
  TimeSavedWithNewsroomsAI: 'Time saved with newsrooms.ai',
  YourProductivityJourneyAwaits: 'Your Productivity Journey Awaits!',
  StartCreatingContentToUnlockAchievements:
    'Start creating content with newsrooms.ai to unlock achievements, save time, and boost your productivity.',
  StartCreating: 'Create Your First Content',
  minutes: 'minutes',
  hour: 'hour',
  ContentGenerated: 'Content Generated',
  pieces: 'pieces',
  WordsGenerated: 'Words Generated',
  CurrentStreak: 'Current Streak',
  LongestStreak: 'Longest Streak',
  YourTimeSavingJourney: 'Your Time-Saving Journey',
  WeeklyProductivity: 'Weekly Productivity',
  AchievementsMilestones: 'Achievements & Milestones',
  YourProductivityImpact: 'Your Productivity Impact',
  total: 'Total',
  saved: 'saved',
  TimeSavedLabel: 'Time Saved: {time} hours',
  TotalTimeSavedLabel: 'Total Time Saved: {time} hours',
  WordsGeneratedLabel: 'Words Generated: {words}',
  TimeSavedCardLabel: 'Time Saved',
  ProductiveDaysCardLabel: 'Productive Days',
  DaysUsingNewsroomsCardLabel: 'Days using newsrooms.ai',
  ContentVelocityCardLabel: 'Content Velocity',
  PiecesPerActiveDayLabel: 'Pieces per active day',
  GenerateMoreContentToSeeTimeSavingTrends: 'Generate more content to see your time-saving trends',
  GenerateContentToSeeWeeklyStats: 'Generate content to see weekly stats',
  basedOn: 'Based on',
  wpmAverage: 'WPM average',
  timeSaved: 'Time saved',
  // Achievements Array
  dyn: {
    ACHIEVEMENTNAME: {
      FirstCreation: 'First Creation',
      ConsistentCreator: 'Consistent Creator',
      TimeSaver: 'Time Saver',
      PowerUser: 'Power User',
      ContentMaster: 'Content Master',
      ProductivityChampion: 'Productivity Champion',
      WordWizard: 'Word Wizard',
      CenturyCreator: 'Century Creator',
      StreakLegend: 'Streak Legend',
      VarietyMaster: 'Variety Master',
      MarathonCreator: 'Marathon Creator'
    },
    ACHIEVEMENTDESC: {
      CreatedyourfirstAIgeneratedcontent: 'Created your first AI-generated content',
      Createdcontentfor7daysinarow: 'Created content for 7 days in a row',
      Saved10hoursofworkwithAI: 'Saved 10 hours of work with AI',
      Generated25000wordswithAI: 'Generated 25,000 words with AI',
      Created50piecesofcontent: 'Created 50 pieces of content',
      Createdcontenton30differentdays: 'Created content on 30 different days',
      Generated100000wordswithAI: 'Generated 100,000 Words with AI',
      Created100piecesofcontent: 'Created 100 pieces of Content',
      Achieveda30daystreak: 'Achieved a 30-day streak',
      Used5differentcontenttypes: 'Used 5 different content types',
      Created10piecesofcontentinoneday: 'Created 10 pieces of content in one day'
    }
  },
  yourProductivity: 'Your Productivity',
  // StatisticsLayout.vue
  manageYourAccountSettingsAndMore: 'Manage your account settings and more',
  // ProfileLayout.vue
  username: 'User name',
  rolesAndPermissions: 'Roles & Permissions',
  keyboardShortcuts: 'Keyboard Shortcuts',
  openSearchShortcut: 'Open Search',
  subscription: 'Subscription',
  cumulativeTimeSaved: 'Total Time Saved',
  PersonalRecords: 'Personal Records',
  CreateContentToSeeRecords: 'Create content to see your personal records',
  MostProductiveDay: 'Most Productive Day',
  BestWeek: 'Best Week',
  LongestStreakRecord: 'Longest Streak',
  ContentTypeDistribution: 'Content Type Distribution',
  CreateContentToSeeDistribution: 'Create content to see distribution',
  TotalContentPieces: '{count} total pieces',
  Other: 'Other',
  PeriodComparison: 'Period Comparison',
  ThisWeek: 'This Week',
  ThisMonth: 'This Month',
  vsLastWeek: 'vs last week',
  vsLastMonth: 'vs last month',
  HourlyActivity: 'Hourly Activity',
  CreateContentToSeeActivity: 'Create content to see your activity pattern',
  MostProductiveAt: 'Most productive at',
  day: 'day',
  days: 'days',
  hours: 'hours',
  words: 'words',
  Date: 'Date',
  Week: 'Week'
}

export const GAMIFICATION_VIEW_DE = {
  YourProductivityDashboard: 'Dein Produktivitäts-Dashboard',
  AchievementsCompleted: 'Erreichte Erfolge',
  LoadingYourProductivityMetrics: 'Deine Produktivitätsdaten werden geladen...',
  TimeSavedWithNewsroomsAI: 'Mit newsrooms.ai gesparte Zeit',
  YourProductivityJourneyAwaits: 'Deine Produktivitätsreise beginnt!',
  StartCreatingContentToUnlockAchievements:
    'Erstelle Inhalte mit newsrooms.ai, um Erfolge freizuschalten, Zeit zu sparen und deine Produktivität zu steigern.',
  StartCreating: 'Erstelle deinen ersten Content',
  minutes: 'Minuten',
  ContentGenerated: 'Erstellte Inhalte',
  pieces: 'Stück',
  WordsGenerated: 'Generierte Wörter',
  CurrentStreak: 'Aktuelle Serie',
  LongestStreak: 'Längste Serie',
  YourTimeSavingJourney: 'Deine Zeitersparnis',
  WeeklyProductivity: 'Wöchentliche Produktivität',
  AchievementsMilestones: 'Erfolge & Meilensteine',
  YourProductivityImpact: 'Deine Produktivität',
  total: 'Gesamt',
  saved: 'gespart',
  TimeSavedLabel: 'Gesparte Zeit: {time} Std.',
  TotalTimeSavedLabel: 'Gesparte Zeit gesamt: {time} Std.',
  WordsGeneratedLabel: 'Generierte Wörter: {words}',
  TimeSavedCardLabel: 'Gesparte Zeit',
  ProductiveDaysCardLabel: 'Produktive Tage',
  DaysUsingNewsroomsCardLabel: 'Tage mit newsrooms.ai',
  ContentVelocityCardLabel: 'Content-Rate',
  PiecesPerActiveDayLabel: 'Stücke pro aktivem Tag',
  GenerateMoreContentToSeeTimeSavingTrends:
    'Erstelle mehr Content, um Zeitersparnis-Trends zu sehen',
  GenerateContentToSeeWeeklyStats: 'Erstelle Content, um Wochen-Statistiken zu sehen',
  basedOn: 'Basiert auf',
  wpmAverage: 'WPM Durchschnitt',
  hour: 'Stunde',
  timeSaved: 'Gesparte Zeit',
  // Achievements Array
  dyn: {
    ACHIEVEMENTNAME: {
      FirstCreation: 'Erste Kreation',
      ConsistentCreator: 'Konsistenter Nutzer',
      TimeSaver: 'Zeitsparer',
      PowerUser: 'Power Nutzer',
      ContentMaster: 'Content Meister',
      ProductivityChampion: 'Produktivitäts Champion',
      WordWizard: 'Wort Zauberer',
      CenturyCreator: 'Creator des Jahrhunderts',
      StreakLegend: 'Serien-Legende',
      VarietyMaster: 'Vielfalt-Meister',
      MarathonCreator: 'Marathon-Creator'
    },
    ACHIEVEMENTDESC: {
      CreatedyourfirstAIgeneratedcontent: 'Sie haben Ihren ersten KI-Generierten Content erstellt',
      Createdcontentfor7daysinarow: '7 Tage in Folge Content erstellt',
      Saved10hoursofworkwithAI: '10 Stunden Arbeit durch KI gespart',
      Generated25000wordswithAI: '25.000 Worte durch KI generiert',
      Created50piecesofcontent: '50 mal Content generiert',
      Createdcontenton30differentdays: 'An 30 verschiedenen Tagen Content generiert',
      Generated100000wordswithAI: '100.000 Worte durch KI generiert',
      Created100piecesofcontent: '100 mal Content generiert',
      Achieveda30daystreak: '30 Tage Serie erreicht',
      Used5differentcontenttypes: '5 verschiedene Content-Typen verwendet',
      Created10piecesofcontentinoneday: '10 Inhalte an einem Tag erstellt'
    }
  },

  yourProductivity: 'Deine Produktivität',
  // StatisticsLayout.vue
  manageYourAccountSettingsAndMore: 'Verwalten Sie Ihre Kontoeinstellungen und mehr',
  // ProfileLayout.vue
  username: 'Benutzername',
  rolesAndPermissions: 'Rollen & Berechtigungen',
  keyboardShortcuts: 'Tastenkurzbefehle',
  openSearchShortcut: 'Suche öffnen',
  subscription: 'Abonnement',
  cumulativeTimeSaved: 'Gesamte Zeitersparnis',
  PersonalRecords: 'Persönliche Rekorde',
  CreateContentToSeeRecords: 'Erstelle Content, um deine persönlichen Rekorde zu sehen',
  MostProductiveDay: 'Produktivster Tag',
  BestWeek: 'Beste Woche',
  LongestStreakRecord: 'Längste Serie',
  ContentTypeDistribution: 'Content-Typ Verteilung',
  CreateContentToSeeDistribution: 'Erstelle Content, um die Verteilung zu sehen',
  TotalContentPieces: '{count} Inhalte gesamt',
  Other: 'Andere',
  PeriodComparison: 'Zeitraum-Vergleich',
  ThisWeek: 'Diese Woche',
  ThisMonth: 'Dieser Monat',
  vsLastWeek: 'vs. letzte Woche',
  vsLastMonth: 'vs. letzter Monat',
  HourlyActivity: 'Aktivität nach Uhrzeit',
  CreateContentToSeeActivity: 'Erstelle Content, um dein Aktivitätsmuster zu sehen',
  MostProductiveAt: 'Am produktivsten um',
  day: 'Tag',
  days: 'Tage',
  hours: 'Stunden',
  words: 'Wörter',
  Date: 'Datum',
  Week: 'Woche'
}
